module.exports = __webpack_public_path__ + "static/media/Take It to the Top.057959ab.jpg";